module.exports = __webpack_public_path__ + "static/img/Philippe-Delorme_2017-18.21d1e9d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/company-performance/leadership/Philippe-Delorme_2017-18.jpg
// module id = +XgK
// module chunks = 0